@let b = brand();
<a class="brand-card" [routerLink]="can_view() ? ['/brands', b.slug] : undefined" [class.brand-card-sm]="small()">
    <img class="brand-image" [src]="b.image_url | bucket:true" draggabe="false" [fallback]="'images/fallback/category.webp'" [alt]="b.name"/>
    <img class="brand-logo" [src]="b.logo_url | bucket:true" draggable="false" [fallback] [alt]="b.name"/>
    <div class="brand-details">
        <div  class="flex-brandname">
            <h3 class="m-0 title font-bold">
                <span>{{b.title || b.name || 'Brand'}}</span>
                @if(b.options?.length){

                    <!-- <mat-icon *ngIf="isVegan" color="primary" svgIcon="vegan" matTooltip="Vegan options available"></mat-icon>
                    <mat-icon *ngIf="isVegetarian" color="primary" svgIcon="vegetarian" matTooltip="Vegetarian options available"></mat-icon>
                    <mat-icon *ngIf="isGlutenFree" color="primary" svgIcon="gluten_free" matTooltip="Gluten-free options available"></mat-icon>
                    <mat-icon *ngIf="isLactoseFree" color="primary" svgIcon="lactose_free" matTooltip="Lactose-free options available"></mat-icon> -->
                }
            </h3>
            @if(b.options?.length; as length){
                <p class="m-0 locality">
                    <mat-icon>menu_book</mat-icon>
                    <span>Menu{{length > 1 ? 's' :'' }} Available</span>
                </p>
            }
        </div>
        <div class="flex-taglist">
            <div class="tags">
                @for(tag of base_tags().slice(0,3); track tag._id){
                    <div [paint]="tag.plan" class="f-cross-center px-8">
                        @if(tag.upgrade){
                            <mat-icon class="sized" svgIcon="star" style="--icon-size: 20px; margin-left: -4px;"></mat-icon>
                        }
                        <span>{{tag.tag_value}}</span>
                    </div>
                }
            </div>
            <div class="button">
                @if(can_view()){
                    <span class="font-bold" paint="dark">
                        SEE OFFERS
                    </span>
                }
            </div>
        </div>
    </div>
</a>

